const ORIGIN = 'https://mxdc.dvg.cn'

function mxdcUrl(value: string | null | undefined): URL | null {
  if (!value?.trim()) return null
  try {
    const url = new URL(value, ORIGIN)
    if (url.origin !== ORIGIN || url.username || url.password || url.protocol !== 'https:') return null
    return url
  } catch {
    return null
  }
}

export function mxdcPng(value: string | null | undefined, prefix: string): string {
  const url = mxdcUrl(value)
  if (!url || !url.pathname.startsWith(prefix) || !/\.png$/i.test(url.pathname)) return ''
  return url.href
}

export function mxdcMapImage(value: string | null | undefined): string {
  return mxdcPng(value, '/dbsource/mapsource/')
}

export function mxdcMobIcon(value: string | null | undefined): string {
  return mxdcPng(value, '/dbsource/mobsource/')
}

export function mxdcItemIcon(value: string | null | undefined): string {
  return mxdcPng(value, '/dbsource/icon/item/')
}

export function mxdcMapPage(value: string | null | undefined): string {
  return mxdcInfoPage(value, '/map_info.php')
}

export function mxdcMobPage(value: string | null | undefined): string {
  return mxdcInfoPage(value, '/mob_info.php')
}

export function mxdcItemPage(value: string | null | undefined): string {
  return mxdcInfoPage(value, '/item_info.php')
}

function mxdcInfoPage(value: string | null | undefined, pathname: string): string {
  const url = mxdcUrl(value)
  if (!url || url.pathname !== pathname) return ''
  const id = url.searchParams.get('id')
  if (!id || !/^\d+$/.test(id)) return ''
  return `${ORIGIN}${pathname}?id=${id}`
}

export function bookletMapUrl(mapId: number): string {
  return `https://mxdc.dvg.cn/map_info.php?id=${mapId}`
}
